import React from "react";
import AbogadosTemplate from "../components/templates/AbogadosTemplate";

const Abogados = () => {
    return(
        <AbogadosTemplate/>
    )
};

export default Abogados;